import { apiSlice } from "../../app/api/apiSlice";

export const tournamentsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTournaments: builder.query({
      query: () => "/tournaments",
      providesTags: (result) =>
        result?.length
          ? [
              ...result.map((t) => ({ type: "Tournament", id: t._id || t.id })),
              { type: "Tournament", id: "LIST" },
            ]
          : [{ type: "Tournament", id: "LIST" }],
    }),
    getTournament: builder.query({
      query: (id) => `/tournaments/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Tournament", id }],
    }),
    createTournament: builder.mutation({
      query: (tournament) => ({
        url: "/tournaments",
        method: "POST",
        body: tournament,
      }),
      invalidatesTags: [{ type: "Tournament", id: "LIST" }],
    }),
    updateTournament: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/tournaments/${id}`,
        method: "PATCH",
        body: patch,
      }),
      invalidatesTags: (_res, _err, { id }) => [
        { type: "Tournament", id },
        { type: "Tournament", id: "LIST" },
      ],
    }),
    deleteTournament: builder.mutation({
      query: (id) => ({
        url: `/tournaments/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (_res, _err, id) => [
        { type: "Tournament", id },
        { type: "Tournament", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetTournamentsQuery,
  useGetTournamentQuery,
  useCreateTournamentMutation,
  useUpdateTournamentMutation,
  useDeleteTournamentMutation,
} = tournamentsApiSlice;
